// extracted by mini-css-extract-plugin
export default {"fullScreenAnimation":"StartupAnimation_fullScreenAnimation__C3-4x"};